/**
 * Recipe Detection Utility
 *
 * Detects if a bookmark is a recipe based on keywords in title, category, or description
 * Supports: de, en, fr, es, it
 */

const RECIPE_KEYWORDS = {
  de: ['rezept', 'zutaten', 'portion', 'mahlzeiten', 'backwaren'],
  en: ['recipe', 'ingredients', 'servings', 'serving', 'meals', 'baked goods', 'pastries'],
  fr: ['recette', 'ingrédients', 'portions', 'repas', 'pâtisseries', 'produits de boulangerie'],
  es: ['receta', 'ingredientes', 'porciones', 'comidas', 'repostería', 'productos de panadería'],
  it: ['ricetta', 'ingredienti', 'porzioni', 'pasti', 'pasticceria', 'prodotti da forno']
};

/**
 * Checks if a bookmark is a recipe
 * @param {Object} bookmark - The bookmark object with title, category, description
 * @returns {boolean} - True if bookmark contains recipe keywords
 */
export const isRecipe = (bookmark) => {
  if (!bookmark) return false;

  const searchText = [
    bookmark.title || '',
    bookmark.category || '',
    bookmark.description || ''
  ].join(' ').toLowerCase();

  // Check all language keywords
  return Object.values(RECIPE_KEYWORDS).some(keywords =>
    keywords.some(keyword => searchText.includes(keyword.toLowerCase()))
  );
};

/**
 * Filters bookmarks to return only recipes
 * @param {Array} bookmarks - Array of bookmark objects
 * @returns {Array} - Array of recipe bookmarks
 */
export const filterRecipes = (bookmarks) => {
  if (!Array.isArray(bookmarks)) return [];
  return bookmarks.filter(isRecipe);
};

/**
 * Gets recipe keywords for a specific language
 * @param {string} lang - Language code (de, en, fr, es, it)
 * @returns {Array} - Array of keywords for that language
 */
export const getRecipeKeywords = (lang = 'en') => {
  return RECIPE_KEYWORDS[lang] || RECIPE_KEYWORDS.en;
};
